import { CoinPack, ShopItem } from '../types';

export const COIN_PACKS: CoinPack[] = [
  {
    id: 'starter-pack',
    name: 'Starter Pack',
    credits: 1200,
    price_brl: 14.9,
    description: 'Bom para destravar alguns itens e entrar nas primeiras apostas.'
  },
  {
    id: 'grind-pack',
    name: 'Grind Pack',
    credits: 3000,
    bonus_credits: 300,
    price_brl: 29.9,
    highlight: 'Mais escolhido',
    description: 'Pacote equilibrado para loja, consumiveis e mais margem no PvP.'
  },
  {
    id: 'legend-pack',
    name: 'Legend Pack',
    credits: 7000,
    bonus_credits: 1200,
    price_brl: 59.9,
    highlight: 'Melhor valor',
    description: 'Para quem quer estoque de moedas e liberdade para gastar sem pensar toda hora.'
  }
];

export const SHOP_ITEMS: ShopItem[] = [
  {
    id: '1',
    name: 'Streak Freeze',
    description: 'Protege sua sequência por 1 dia se você falhar.',
    price: 500,
    type: 'utility',
    icon_name: 'Snowflake',
    owned: false,
    effect: { type: 'streak_freeze', duration: 24 }
  },
  {
    id: '2',
    name: 'Neon Frame',
    description: 'Borda neon exclusiva para seu avatar.',
    price: 1200,
    type: 'cosmetic',
    icon_name: 'Frame',
    owned: false,
    effect: { type: 'cosmetic' }
  },
  {
    id: '3',
    name: 'XP Booster 24h',
    description: 'Ganhe 20% mais XP em todas as tarefas por 24h.',
    price: 800,
    type: 'boost',
    icon_name: 'Zap',
    owned: false,
    effect: { type: 'xp_boost', duration: 24, multiplier: 1.2 }
  },
  {
    id: '4',
    name: 'Dark Soul Theme',
    description: 'Tema preto absoluto para telas OLED.',
    price: 2000,
    type: 'cosmetic',
    icon_name: 'Crown',
    owned: false,
    effect: { type: 'cosmetic' }
  }
];

export const getShopItemById = (itemId: string) => {
  return SHOP_ITEMS.find((item) => item.id === itemId) || null;
};
